import { useLingui } from '@lingui/react/macro';

import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import { REFASHION_ACTIONS, RefashionAction } from '@/models/actionType';

export const RefashionIdSelect = ({
  refashionId,
  setRefashionId,
}: {
  refashionId: RefashionAction | null;
  setRefashionId: (refashionId: RefashionAction | null) => void;
}) => {
  const { t } = useLingui();

  return (
    <InputSelect
      options={REFASHION_ACTIONS.map((id) => ({ id }))}
      value={refashionId ? { id: refashionId } : undefined}
      label={t({
        id: 'settings.actions.actions.drawer.refashion-id',
        message: 'Refashion action',
      })}
      placeholder={t({
        id: 'settings.actions.actions.drawer.refashion-id',
        message: 'Refashion action',
      })}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.id}
      onChange={(option) => setRefashionId(option?.id ?? null)}
      isClearable
    />
  );
};
